module.exports = __webpack_public_path__ + "img/logo3.01355853.webp";